module.exports = __webpack_public_path__ + "static/img/年度最佳创新家电.3e9dd220.png";